module.exports = __webpack_public_path__ + "static/img/Josh-Green.2c76932.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Josh-Green.jpg
// module id = dm7B
// module chunks = 1